package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class LanguageItem(
    val language: Language,
    val level: Level
)
